module.exports = __webpack_public_path__ + "img/img1.f444ca6b.jpg";